import React, { useState, useEffect } from "react";
import Layout from "../Layout/Layout";
import { isAuthenticated} from '../auth';
import { Link} from "react-router-dom";
import { Languages, Pencil, Trash2, ListTree, Plus, AlertTriangle } from "lucide-react";
import { AddFilterName, getFilterName, deteleFilter, updateFilter, updateTranslFil} from "../auth/apiCategory";
import Modal from 'react-bootstrap/Modal';
import JsonAddLangueCat from "../pageInside/JsonAddLangueCat";
import EditableFilter from "../pageInside/editFilterElakay";
import PageAddSubFilters from "../pageInside/pageAddSubFilters";
import "./adminPages.css";
import { elakayAutoText } from "../pageInside/dataElakay";

const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#d1fae5",
  red: "#ef4444", redLt: "#fee2e2",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
};

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addFilters"]?.[key] || fallback;

const CreatCategory = props => {
    const {
        infoSource,
        laguangeElakay
            } = props;

  __setElakayInfoSource(infoSource);
  const {
    getButtonTitle
    } = infoSource;
    const { token} = isAuthenticated();
    const [name, setName] = useState("");
    const [filters, setFilters] = useState([]);
    const [showJsonAdd, setShowJsonAdd] = useState(false)
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [reName, setReName] = useState("");
    const [message, setMessage] = useState(false);
    const [success, setSuccess] = useState(false);
     const [filterItem, setFilterItem] = useState({})
    const [showDeleteAgree, setDeleteAgree] = useState(false);
    const [showEditName, setEditName] = useState(false);
     const [showSubFilters, setSubFilters] = useState(false);
    const [chek, setChek] = useState(false);
    const [seletName, setSeletName] = useState('');
    const handl = (a) => {
        setChek(a)
    }

    useEffect(() => {
        loadFilters(token)
    }, [token])

 const submitJsonInput =(value)=>{

        try {
            updateTranslFil(token, JSON.parse(value.getJsonInput), value.id ).then(data => {
                if (data.error) {
                    value.setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }))
                } else {
                    setShowJsonAdd(false)
                    loadFilters(token)
                    value.setErrorMessage(null)
                }
            });
        // setNewObejet(JSON.stringify(obj,  null, 3))
        value.setErrorMessage(null)
      //
        } catch (error) {
      // Afficher l'erreur si le parsing échoue
      value.setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }));
      }
      }
    const clickSubmit = e => {
        e.preventDefault();

        setError("");
        setSuccess(false);
        // make request to api to create category
        AddFilterName (token, {name}).then(data => {
            if (data.error) {
                // loadCategory(elakayCategoryID);
                setError(data.error);
            } else {

                setError("");
                setSuccess(true);
                setMessage(elakayAutoText("h_412abc99ae3ad7", "the filters name: {value0} is Create", { value0: name }))
                setName("")
                loadFilters(token)

            }
        });
    };
// const LinkHref = (path)=>{
//     navigate(path)
// }
    const deleteFIL = (filterID, token) => {
        deteleFilter(filterID ,token).then(data => {
            if (data.error) {
                setError(data.error);
                // loadCategory(categoryID)
            } else {
                setError(false);
                setSuccess(true);
                setMessage(elakayAutoText("h_a66f98175b06a4", "sub Items name {value0} is deleted", { value0: name }))
                loadFilters(token)
                setDeleteAgree(false)
                setChek(false)
            }
        });
    };

    const handleChange = e => {
        setError('');
        setName(e.target.value);
    };

    const loadFilters = (token) => {
        getFilterName(token).then(data => {
            if (data.error) {
            } else {
                setFilters(data)
                setLoading(false)
            }
        });
    };

    const SubmitB = (name) => {
        setSeletName(name)
        setDeleteAgree(true)
        setEditName(false)
    }

    const SubmitA = (name) => {
        setSeletName(name)
        setDeleteAgree(false)
        setEditName(true)

    }

    const btnTranslateCat =(value)=>{
        setShowJsonAdd(true)
        setFilterItem(value)
    }

const clickSubmitEdit = (id, data) => {
        updateFilter(token, id, data).then(data => {
            if (data.error) {
                setError(data.error);
            } else {
                setEditName(false)
                loadFilters(token)
            }
        });
    };

    // ─── Shared primitives ───────────────────────────────────────────────────
    const showSuccess = () => !success ? null : (
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.greenLt, borderRadius: 8, border: "1px solid #86efac", marginBottom: 14 }}>
        <span style={{ fontSize: 12, color: "#065f46", fontWeight: 500 }}>{message}</span>
      </div>
    );

    const showError = () => !error ? null : (
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginBottom: 14 }}>
        <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
        <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{error}</span>
      </div>
    );

    const deleteAgree = (name, filterID, token) => (
      <Modal show={showDeleteAgree} onHide={() => setDeleteAgree(false)} centered aria-labelledby="delete-filter-title">
        <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
          <Modal.Title id="delete-filter-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.redLt, color: "#991b1b", flexShrink: 0 }}>
              <Trash2 size={16} />
            </span>
            <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
              {infoSource.language(infoSource, "title", "delThtems")}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
          <p style={{ fontSize: 13, color: D.txt2 }}>
            {infoSource.language(infoSource, "title", "surToDelete")}
            <span style={{ color: D.red, fontWeight: 700 }}> {name}</span>
          </p>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: D.txt2, cursor: "pointer" }}>
            <input
              onChange={() => handl(chek ? false : true)}
              type="checkbox"
              checked={chek}
              style={{ width: 16, height: 16, cursor: "pointer" }}
            />
            {infoSource.language(infoSource, "title", "chButAgree")}
          </label>
        </Modal.Body>
        <Modal.Footer style={{ background: D.bg, borderTop: `1px solid ${D.border}`, fontFamily: D.font }}>
          <button
            onClick={chek ? () => deleteFIL(filterID, token) : undefined}
            disabled={!chek}
            style={{
              padding: "9px 20px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600,
              fontFamily: D.font, cursor: chek ? "pointer" : "not-allowed",
              background: chek ? D.red : "#cbd5e1", color: chek ? "#fff" : "#94a3b8",
            }}
          >
            {infoSource.language(infoSource, 'Button', "submit")}
          </button>
        </Modal.Footer>
      </Modal>
    );

    const editNameCat = (name, FilterItem, filter_id ) => (
      <Modal show={showEditName} onHide={() => setEditName(false)} size="lg" centered aria-labelledby="edit-filter-title">
        <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
          <Modal.Title id="edit-filter-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
              <Pencil size={16} />
            </span>
            <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
              {__elakayText("t003", "Add, Edit & Remove Filter")} {name}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
          <EditableFilter
            infoSource={infoSource}
            filter = {{name, FilterItem, filter_id}}
            clickSubmitEdit={clickSubmitEdit}
          />
        </Modal.Body>
      </Modal>
    );

    const addSubFilters = () => (
      <Modal size="xl" show={showSubFilters} onHide={() => setSubFilters(false)} centered aria-labelledby="sub-filters-title">
        <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
          <Modal.Title id="sub-filters-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
              <ListTree size={16} />
            </span>
            <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
              {__elakayText("t004", "Add, Edit & Remove sub Filter")}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
            <PageAddSubFilters
            infoSource ={infoSource}
             filters ={filters}
             token={token}
             loadFilters={loadFilters}
            />
        </Modal.Body>
      </Modal>
    );

    const CategoryFom = () => (
        <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: 12, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
                  <ListTree size={20} />
                </span>
                <h1 style={{ fontSize: 19, fontWeight: 700, color: D.txt1, margin: 0 }}>
                  {infoSource.language(infoSource, "title", "FilElakay")}
                </h1>
              </div>
              <button
                type="button"
                onClick={() => setSubFilters(!showSubFilters)}
                title={getButtonTitle("linkFilter")}
                style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 14px", borderRadius: 8, border: `1px solid ${D.border}`, background: "#fff", color: D.txt2, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}
              >
                <ListTree size={14} />
                {__elakayText("t002", "Sub filters")}
              </button>
            </div>
            {showSuccess()}
            {showError()}

            <div className="admin-card" style={{ overflow: "hidden" }}>

                {filters?.map((c, i) => (
                    <div key={i} className="admin-row" style={{ padding: "10px 16px", borderBottom: `1px solid ${D.border}`, flexWrap: "wrap" }}>
                        <Link to={`items/${c.publicId || c._id}`} style={{ flex: 1, minWidth: 120, fontSize: 13, color: D.txt1, fontWeight: 600, textDecoration: "none" }}>
                            {c.name}
                        </Link>
                        <button
                          type="button"
                          onClick={()=>btnTranslateCat({name: c.name, filter_id: c._id, FilterItem: c.FilterItem, lang: c.lang})}
                          title={getButtonTitle("addLangFilter")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <Languages size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={() => SubmitA(c.name)}
                          title={getButtonTitle("editFilter")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <Pencil size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={() => SubmitB(c.name)}
                          title={getButtonTitle("deleteFilter")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.redLt; e.currentTarget.style.color = D.red; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <Trash2 size={15} />
                        </button>
                        {(c.name === seletName) && deleteAgree(c.name, c._id, token)}
                        {(c.name === seletName) && editNameCat(c.name, c.FilterItem, c._id)}
                    </div>
                ))}

                <form onSubmit={clickSubmit} style={{ display: "flex", gap: 10, padding: 16 }}>
                    <input
                        onBlur={() => setMessage("")}
                        type="text"
                        style={{ flex: 1, padding: "9px 12px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, color: D.txt1, outline: "none", fontFamily: D.font, boxSizing: "border-box" }}
                        placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addFilters.t001}
                        onChange={handleChange}
                        value={name}
                        autoFocus
                        required
                    />
                    <button
                      type="submit"
                      title={getButtonTitle("submit")}
                      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 38, height: 38, borderRadius: 8, border: "none", background: D.blue, color: "#fff", cursor: "pointer", flexShrink: 0 }}
                    >
                      <Plus size={18} />
                    </button>
                </form>
            </div>

        </div>
    )

    return (
        <Layout
            infoSource ={infoSource}
            className="container blockEl"
            SliderPunShow={false}
            loading={loading}
             {...infoSource?.allSettings?.layout}
        >
        <JsonAddLangueCat
            infoSource ={infoSource}
            showJsonAdd={showJsonAdd}
            setShowJsonAdd={setShowJsonAdd}
            catalogItem={filterItem}
            submitJsonInput={submitJsonInput}
            filter={true}
            />
            <div style={infoSource.styleNav}>
            <div className="admin-container" style={{ fontFamily: D.font }} onBlur={() => setMessage("")}>
                {CategoryFom()}
            </div>
            </div>
            {addSubFilters()}
        </Layout>
    );
};

export default CreatCategory;
